<form class="wrapper" [formGroup]="formGroup">
	<ng-container *ngIf="lineitem">
		<h2 *ngIf="lineitem?.id">{{ 'EDIT_' + label | translate }} </h2>
		<h2 *ngIf="!lineitem?.id">{{ 'CREATE_NEW_' + label | translate }} </h2>
		<div class="status">
			<bb-status *ngIf="lineitem" formControlName="status" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate" [valueOn]="'published'" [valueOff]="'draft'"></bb-status>
		</div>
		<bb-form-element [control]="formGroup.get('title')" [label]="'TITLE' | translate">
			<bb-text required formControlName="title"></bb-text>
		</bb-form-element>

		<bb-form-element [control]="formGroup.get('code')" [label]="'CODE' | translate">
			<bb-text [disabled]="!!lineitem?.id" formControlName="code"></bb-text>
		</bb-form-element>

		<bb-form-element [control]="formGroup.get('timeout')" [label]="'TIMEOUT' | translate">
			<input type="number" formControlName="timeout" />
		</bb-form-element>

		<div class="vast-buttons {{ lineitem.vast_url ? '' : 'disabled' }}">
			<a href="https://support.bluebillywig.com/vast-inspector#!/vast_type=vast_url/vast_url={{getVastUrl()}}" target="_blank" class="button">
				<i class="fa fa-external-link"></i> {{ 'OPEN_IN_VAST_INSPECTOR' | translate }}
			</a>
			<button class="button" (click)="copyVastUrlToClipboard()"><i class="fa fa-copy"></i> {{ 'COPY_URL' | translate }}</button>
		</div>	

		<bb-form-element [control]="formGroup.get('vast_url')" [label]="'VAST_URL' | translate">
			<textarea formControlName="vast_url"></textarea>
		</bb-form-element>

	</ng-container>
</form>
<div class="actions" *ngIf="lineitem">
	<button *ngIf="!unlink" class="button" (click)="delete()" [hidden]="!lineitem?.id"><i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</button>
	<button *ngIf="unlink" class="button" (click)="delete()" [hidden]="!lineitem?.id"><i class="fa fa-unlink"></i> {{ 'UNLINK' | translate }}</button>
	<button *ngIf="lineitem?.id" class="button submit" (click)="saveQuickEdit()"><i class="fa fa-floppy-o"></i> {{ 'SAVE' || translate }}</button>
	<button class="button cancel" (click)="onCancelClick()"><i class="fa fa-ban"></i> {{ 'CANCEL' | translate }}</button>
</div>
